import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {
  constructor(private authService: AuthorizationService, private router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isUserSalesRep()) {
      this.router.navigate(['features/reports/commision'])
      return false
    }
    if (this.authService.isUserBillingDpt()) {
      this.router.navigate(['features/reports/payment-report'])
      return false
    }
    if (!this.authService.isPrimaryUser()) {
      this.router.navigate(['features/reports/transaction-summary'])
      return false
    }

    return true;
  }
}
